/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

export enum PasswordRuleStatus {
  Default = 'default',
  Valid = 'valid',
  Invalid = 'invalid',
}
